import { BuyAtNavIndicator, SourceOfFunds } from '../models/mutualfund/trading-mutualfund.model';

export abstract class TradingConstants {
    static BUY_VIEW = 'BUY_VIEW';
    static SELL_VIEW = 'SELL_VIEW';
    static DEFAULT_VIEW = 'DEFAULT_VIEW';
    static SHORT_SALE_DEEMED_OWN = 's*deemed to own';
    static USD = 'USD';
    static MF_EXCHANGE_VIEW = 'MF_EXCHANGE_VIEW';
    static ANNUITY = 'annuity';
    static FIXED_INCOME_TYPE = 'fixed income';
    static CURRENCY_TYPE = 'currency';
    static INTERNATIONAL_TYPE = 'international trade';
    static NXI_ORDER_STATUS_URL = '/nxi/transact/orderstatus';

    static ORDER_STATUS_KEY = 'nxi/transact/orderstatus';
    static HISTORY_KEY = '/nxi/accounts/history';
    static ALL_HISTORY_KEY = '/nxi/portfolio/history';
    static RESEARCH_KEY = 'nxi/research/markets/usmarkets';
    static AMERICA_NEWYORK = 'America/New_York';
    static MAX_ORDERS = 5;
    static DISC_EXERCISE = 'Discretion Exercised';
    static DISC_NOT_EXERCISE = 'Discretion Not Exerc';
}

export const enum TRADING_PLATFORM {
    PROFESSIONAL = 'professional',
    RETAIL = 'retail'
}

export const enum ORDER_ACTIONS {
    CANCEL = 'CANCEL',
    CHANGE = 'CHANGE',
    CORRECT = 'CORRECT',
    SELL_TAXLOT = 'SELL_TAXLOT'
}

export const enum TRADING_SETTINGS_ASSET_TYPE {
    EQT = 'EQT',
    MFT = 'MFT',
    OPT = 'OPT'
}

export const enum TRADING_SETTINGS_ROLE {
    ADMIN = 'ADMIN',
    USER = 'USER'
}

export const TAXLOT_DISPOSITION_METHOD_LIST = [
    { code: 'FI', label: 'TAX_LOT.DISP_METHOD_SELECTION.FI'},
    { code: 'LI', label: 'TAX_LOT.DISP_METHOD_SELECTION.LI'},
    { code: 'HC', label: 'TAX_LOT.DISP_METHOD_SELECTION.HC'},
    { code: 'LC', label: 'TAX_LOT.DISP_METHOD_SELECTION.LC'},
    { code: 'HL', label: 'TAX_LOT.DISP_METHOD_SELECTION.HL'},
    { code: 'HS', label: 'TAX_LOT.DISP_METHOD_SELECTION.HS'},
    { code: 'LL', label: 'TAX_LOT.DISP_METHOD_SELECTION.LL'},
    { code: 'LS', label: 'TAX_LOT.DISP_METHOD_SELECTION.LS'},
    { code: 'AV', label: 'TAX_LOT.DISP_METHOD_SELECTION.AV'},
    { code: 'MS', label: 'TAX_LOT.DISP_METHOD_SELECTION.MS'}
];

export const TAXLOT_DISPOSITION_METHOD_LIST_DISPLAY = [
    { code: 'FI', label: 'TAX_LOT.DISP_METHOD_SELECTION.FI'},
    { code: 'LI', label: 'TAX_LOT.DISP_METHOD_SELECTION.LI'},
    { code: 'HC', label: 'TAX_LOT.DISP_METHOD_SELECTION.HC'},
    { code: 'LC', label: 'TAX_LOT.DISP_METHOD_SELECTION.LC'},
    { code: 'HL', label: 'TAX_LOT.DISP_METHOD_SELECTION.HL'},
    { code: 'HS', label: 'TAX_LOT.DISP_METHOD_SELECTION.HS'},
    { code: 'LL', label: 'TAX_LOT.DISP_METHOD_SELECTION.LL'},
    { code: 'LS', label: 'TAX_LOT.DISP_METHOD_SELECTION.LS'},
    { code: 'MS', label: 'TAX_LOT.DISP_METHOD_SELECTION.MS'}
];

export const enum PLAN_529_CONTRIBUTION_TYPE {
    CURRENT_YEAR = 'CURRENT_YEAR',
    PRIOR_YEAR = 'PRIOR_YEAR',
    ROLLOVER = 'ROLLOVER'
}

export const PLAN_529_CONTRIBUTION_OPTIONS = [
    PLAN_529_CONTRIBUTION_TYPE.CURRENT_YEAR,
    PLAN_529_CONTRIBUTION_TYPE.PRIOR_YEAR,
    PLAN_529_CONTRIBUTION_TYPE.ROLLOVER
];

export const enum ROLLOVER_EARNINGS_GAIN_LOSS {
    GAIN = 'GAIN',
    LOSS = 'LOSS'
}

export const ROLLOVER_EARNINGS_OPTIONS = [
    ROLLOVER_EARNINGS_GAIN_LOSS.GAIN,
    ROLLOVER_EARNINGS_GAIN_LOSS.LOSS
];

export const MF_NAV_REASON_OPTIONS = [
    BuyAtNavIndicator.NO,
    BuyAtNavIndicator.YES_NAV_TRANSFER,
    BuyAtNavIndicator.YES_REPURCHASES,
    BuyAtNavIndicator.YES_EMPLOYEE_REP,
    BuyAtNavIndicator.YES_ERROR_CORRECTION,
    BuyAtNavIndicator.YES_WRAP_FEE_ACCT,
    BuyAtNavIndicator.YES_NAV_COMMISSIONABLE,
    BuyAtNavIndicator.YES_COMM_DEFINED_CONTRIBUTION_PLAN,
    BuyAtNavIndicator.YES_NON_COMM_DEFINED_CONTRIBUTION_PLAN,
    BuyAtNavIndicator.YES_DIVIDEND_REINVESTMENT_TRADE,
    BuyAtNavIndicator.YES_TRUST_ACCT,
    BuyAtNavIndicator.YES_SELF_DIRECTED,
    BuyAtNavIndicator.YES_OTHERS,
    BuyAtNavIndicator.YES_529_ACCT_QUALIFIED
];

export const MF_SOURCE_OF_FUNDS_OPTIONS = [
    SourceOfFunds.CREDIT_BAL_MONEY_MKT,
    SourceOfFunds.MF_UIT_REDEMPTION,
    SourceOfFunds.ANNUITY_REDEMPTION,
    SourceOfFunds.NEW_MONIES,
    SourceOfFunds.OTHER_ADVISORY_ACCT,
    SourceOfFunds.ROLLOVER_QUALIFIED_ACCT,
    SourceOfFunds.SECURITIES_LIQUIDATION
];

export const enum CONTAINER_TYPE {
    Equity = 'Equity',
    MutualFund = 'MutualFund',
    Mutual_Fund = 'Mutual Fund',
    Option = 'Option',
    Plan529 = 'Plan529',
    Extended = 'Extended'
}

export const enum ALERT_MESSAGE_LEVEL {
    info = "info",
    confirm = "confirm",
    warn = "warn",
    error = "error"
}
